/**
 * 契約登録のステップ
 */
export const CONTRACT_REGISTRATION_STEP = {
  INPUT: 'input',
  CONFIRMATION: 'confirmation',
} as const;

/**
 * 契約登録のステップのコード値
 */
export type ContractRegistrationStep =
  typeof CONTRACT_REGISTRATION_STEP[keyof typeof CONTRACT_REGISTRATION_STEP];
